import { render, staticRenderFns } from "./RenewTh.vue?vue&type=template&id=1fdf0db2&scoped=true&"
var script = {}
import style0 from "./RenewTh.vue?vue&type=style&index=0&id=1fdf0db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf0db2",
  null
  
)

export default component.exports